<div class="container-fluid platformsPage py-3">
  <div class="row">

    <div class="col-12">

      <p-table #dt
        currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} plataformas"
        [filterDelay]="0"
        [paginator]="true"
        [rows]="10"
        [rowHover]="true"
        [rowsPerPageOptions]="[10,25,50]"
        [showCurrentPageReport]="!platformService.loading"
        [value]="platformService.loading ? skeletonRows : platformService.platforms">

        <!-- ---------------------------------------------------------------- -->
        <!--                          ANCHOR CAPTION                          -->
        <!-- ---------------------------------------------------------------- -->
        <ng-template pTemplate="caption">
          <div class="container-fluid px-0">

            <!-- Un solo row: el responsive se resuelve con col-12 col-lg-*,
                 no abriendo filas extra. -->
            <div class="row g-2 align-items-center">

              <div class="col-12 col-lg placeholder-glow">
                <h1 class="platformsPage__title mb-1">Plataformas</h1>

                @if (platformService.loading) {
                  <span
                    class="placeholder col-5 rounded d-inline-block platformsPage__skeletonText"
                    aria-hidden="true">
                  </span>
                } @else {
                  <p class="platformsPage__subtitle mb-0">
                    {{ platformService.platforms.length }}
                    {{ platformService.platforms.length === 1
                        ? 'plataforma registrada'
                        : 'plataformas registradas' }}
                  </p>
                }
              </div>

              <div class="col-12 col-lg-auto">
                <div class="d-flex align-items-center justify-content-lg-end gap-2">

                  <button
                    (click)="open()"
                    type="button"
                    class="btn btn-success rounded-circle platformsPage__iconBtn"
                    aria-label="Registrar una nueva plataforma"
                    title="Nueva plataforma">
                    <i class="material-icons" aria-hidden="true">add</i>
                  </button>

                  <button
                    (click)="platformService.getAll()"
                    type="button"
                    class="btn btn-primary rounded-circle platformsPage__iconBtn"
                    aria-label="Actualizar la lista de plataformas"
                    title="Actualizar">
                    <i class="material-icons" aria-hidden="true">refresh</i>
                  </button>

                </div>
              </div>

            </div>
          </div>
        </ng-template>

        <!-- ---------------------------------------------------------------- -->
        <!--                          ANCHOR HEADER                           -->
        <!-- ---------------------------------------------------------------- -->
        <ng-template pTemplate="header">
          <tr>

            <th pSortableColumn="sku">
              SKU
              <p-sortIcon field="sku"></p-sortIcon>
              <p-columnFilter type="text" field="sku" display="menu"></p-columnFilter>
            </th>

            <th class="d-none d-lg-table-cell" pSortableColumn="appName">
              Aplicación
              <p-sortIcon field="appName"></p-sortIcon>
              <p-columnFilter type="text" field="appName" display="menu"></p-columnFilter>
            </th>

            <th class="d-none d-lg-table-cell" pSortableColumn="createdAt">
              Alta
              <p-sortIcon field="createdAt"></p-sortIcon>
            </th>

            <th class="d-none d-lg-table-cell" pSortableColumn="updatedAt">
              Última actualización
              <p-sortIcon field="updatedAt"></p-sortIcon>
            </th>

            <th class="text-end">Acciones</th>
          </tr>
        </ng-template>

        <!-- ---------------------------------------------------------------- -->
        <!--                           ANCHOR BODY                            -->
        <!-- ---------------------------------------------------------------- -->
        <ng-template pTemplate="body" let-platform>

          @if (platformService.loading) {

            <!-- Esqueleto por celda: reserva el alto final de la fila para que
                 la tabla no salte al llegar los datos. -->
            <tr class="placeholder-glow" aria-hidden="true">
              <td>
                <span class="placeholder col-8 rounded d-block platformsPage__skeletonCell"></span>
              </td>
              <td class="d-none d-lg-table-cell">
                <span class="placeholder col-7 rounded d-block platformsPage__skeletonCell"></span>
              </td>
              <td class="d-none d-lg-table-cell">
                <span class="placeholder col-6 rounded d-block platformsPage__skeletonCell"></span>
              </td>
              <td class="d-none d-lg-table-cell">
                <span class="placeholder col-6 rounded d-block platformsPage__skeletonCell"></span>
              </td>
              <td class="text-end">
                <span class="placeholder col-5 rounded d-inline-block platformsPage__skeletonCell"></span>
              </td>
            </tr>

          } @else {

            <!-- Fila-enlace: el clic en cualquier celda abre el detalle, igual
                 que el boton de tres puntos. Se conserva el rol nativo de fila
                 (no se pisa con role="button") para no romper la navegacion por
                 tabla del lector de pantalla; la fila se anuncia con aria-label
                 y se activa con Enter o Espacio, y el enlace real de la celda de
                 acciones sigue siendo la salida semantica de la accion. -->
            <tr
              (click)="goToDetail(platform)"
              (keydown.enter)="goToDetail(platform, $event)"
              (keydown.space)="goToDetail(platform, $event)"
              class="p-selectable-row platformsPage__row"
              tabindex="0"
              [attr.aria-label]="'Ver el detalle de la plataforma ' + platform.sku">

              <td>
                <div class="d-flex flex-column platformsPage__cell">
                  <span class="platformsPage__sku text-truncate">{{ platform.sku }}</span>

                  <!-- En < lg aquí baja lo que las columnas ocultas ya no muestran. -->
                  <span class="platformsPage__cellMeta d-lg-none text-truncate">
                    @if (platform.appName) {
                      {{ platform.appName }}
                    } @else {
                      Sin nombre de app
                    }
                  </span>

                  <span class="platformsPage__cellMeta d-lg-none text-truncate">
                    Actualizada {{ platform.updatedAt | dateToMoment: 'DD MMM YYYY HH:mm' }}
                  </span>
                </div>
              </td>

              <td class="d-none d-lg-table-cell">
                @if (platform.appName) {
                  <span class="platformsPage__cellText">{{ platform.appName }}</span>
                } @else {
                  <!-- Campo sin capturar: gris + texto explícito, nunca rojo. -->
                  <span class="platformsPage__cellOff">Sin nombre de app</span>
                }
              </td>

              <td class="d-none d-lg-table-cell">
                <span class="platformsPage__cellText">
                  {{ platform.createdAt | dateToMoment: 'DD MMM YYYY HH:mm' }}
                </span>
              </td>

              <td class="d-none d-lg-table-cell">
                <span class="platformsPage__cellText">
                  {{ platform.updatedAt | dateToMoment: 'DD MMM YYYY HH:mm' }}
                </span>
              </td>

              <td class="text-end">
                <!-- Cada accion detiene la propagacion: el clic pertenece al
                     boton, no a la fila, y no debe disparar su navegacion. -->
                <div class="d-flex justify-content-end platformsPage__actions">

                  <a
                    (click)="$event.stopPropagation()"
                    [routerLink]="[platform.platformId]"
                    class="btn btn-light rounded-circle platformsPage__iconBtn"
                    [attr.aria-label]="'Ver el detalle de la plataforma ' + platform.sku"
                    title="Ver detalle">
                    <i class="material-icons" aria-hidden="true">more_vert</i>
                  </a>

                  <button
                    (click)="$event.stopPropagation(); open(platform)"
                    type="button"
                    class="btn btn-light rounded-circle platformsPage__iconBtn"
                    [attr.aria-label]="'Editar la plataforma ' + platform.sku"
                    title="Editar">
                    <i class="material-icons" aria-hidden="true">edit</i>
                  </button>

                  <button
                    (click)="$event.stopPropagation(); delete(platform)"
                    type="button"
                    class="btn btn-danger rounded-circle platformsPage__iconBtn"
                    [attr.aria-label]="'Eliminar la plataforma ' + platform.sku"
                    title="Eliminar">
                    <i class="material-icons" aria-hidden="true">delete</i>
                  </button>

                </div>
              </td>

            </tr>

          }

        </ng-template>

        <!-- ---------------------------------------------------------------- -->
        <!--                        ANCHOR EMPTY STATE                        -->
        <!-- ---------------------------------------------------------------- -->
        <ng-template pTemplate="emptymessage">
          @if (!platformService.loading) {
            <tr>
              <td colspan="5">
                <div class="platformsPage__emptyState d-flex flex-column align-items-center justify-content-center text-center">
                  <i class="material-icons platformsPage__emptyIcon" aria-hidden="true">apps</i>
                  <p class="platformsPage__emptyTitle mb-1">Aún no hay plataformas</p>
                  <p class="platformsPage__emptyText mb-3">
                    Registra la primera plataforma para empezar a administrarlas desde aquí.
                  </p>
                  <button
                    (click)="open()"
                    type="button"
                    class="btn btn-outline-primary platformsPage__emptyBtn">
                    Registrar plataforma
                  </button>
                </div>
              </td>
            </tr>
          }
        </ng-template>

      </p-table>

    </div>

    @if (platformService.loading) {
      <div class="col-12 visually-hidden" role="status" aria-live="polite">
        Cargando plataformas
      </div>
    }

  </div>
</div>
